import React from 'react';
import clsx from 'clsx';

import './index.scss';

const RequiredOrOptionalIcon = ({ label }) => {

  return (
    <div className={clsx('RequiredOrOptionalIcon',
      { hidden: !label || label === '非表示' },
      { optional: label === '任意' },
      { required: label === '必須' })
    }>
      {label}
    </div>
  );
};

export default RequiredOrOptionalIcon;